import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { IAPIResponse } from '../../shared/models';
import { IPurchaseOrder_New, IPurchaserOrder } from '../models';
import { EncryptionService } from '../../dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class PoBuyerService {

  constructor(private http: HttpClient, private _encryptionService:EncryptionService) { }

  public getPOConfirmation(): Observable<IAPIResponse<IPurchaserOrder[]>> {
    return this.http.get<IAPIResponse<IPurchaserOrder[]>>(`${API_URL.PO_BUYER.PO_CONFIRMATION}`);
  }

  public updatePOConfirmation(body : { data : IPurchaseOrder_New[]}): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.PO_BUYER.PO_CONFIRMATION}`, body);
  }

  public uploadPOFile(formData : FormData): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.PO_BUYER.PO_FILE}`, formData);
  }

  public downloadPOFile(doc_type  : "INVOICE" | "POD", po_number : string, line_item_number : any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_BUYER.PO_FILE}?po_no=${this._encryptionService.encryptPayload(encodeURIComponent(po_number))}&doc_type=${this._encryptionService.encryptPayload(encodeURIComponent(doc_type))}&line_item_number=${this._encryptionService.encryptPayload(encodeURIComponent(line_item_number))}`, {
      responseType: 'blob' as any,
    });
  }

}
